import { legacy_createStore as createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { thunk } from 'redux-thunk'
import { businessesReducer } from './reducers/businessesReducer'
import { parametersReducer } from './reducers/parametersReducer'
import { analisysTypesReducer } from './reducers/analisysTypesReducer'
import { workOrdersReducer } from './reducers/workOrdersReducer'
import { operatorsReducer } from './reducers/operatorsReducer'
import { analisesReducer } from './reducers/analisesReducer'
import { movementsReducer } from './reducers/movementsReducer'
import { balancesReducer } from './reducers/balancesReducer'
import { billsReducer } from './reducers/billsReducer'
import { logsReducer } from './reducers/logsReducer'
import { usersReducer } from './reducers/usersReducer'
import { budgetsReducer } from './reducers/budgetsReducer'

const intialState = {}
const appReducer = combineReducers({
    businesses: businessesReducer,
    parameters: parametersReducer,
    analisysTypes: analisysTypesReducer,
    analises: analisesReducer,
    budgets: budgetsReducer,
    workOrders: workOrdersReducer,
    operators: operatorsReducer,
    movements: movementsReducer,
    balances: balancesReducer,
    bills: billsReducer,
    users: usersReducer,
    logs: logsReducer
})

const reducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}

const composeEnhancer = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
    reducer,
    intialState,
    composeEnhancer(applyMiddleware(thunk))
)

export default store